import { getApi } from './api';

class NewsletterWidget {
  constructor(selector, api, userStatus) {
    const $ = window.$;
    this.$element = $(selector);
    this.$button = $('.newsletter__button .btn', this.$element);
    this.$icon = $('.newsletter__button-icon', this.$element);
    this.api = api;
    this.loginStatus = userStatus.loginStatus;
  }

  init() {
    const self = this;
    switch (this.loginStatus) {
      case 'Anonymous':
        this.show();
        this.$button.on('click', function () {
          self.registerHandler();
        });
        break;
      case 'Pending':
        window.createPendingWidget();
        break;
      default:
        this.api.isSubscribed().then((isSubscribed) => {
          if (!isSubscribed) {
            this.show('Iscriviti');
            this.$button.on('click', function () {
              self.subscribeHandler();
            });
          }
        });
        break;
    }
  }

  show(buttonText) {
    if (typeof buttonText !== 'undefined') {
      this.setButtonText(buttonText);
    }
    this.$element.slideDown();
  }

  setButtonText(text) {
    this.$button.html(text);
  }

  disableButton() {
    this.$button.attr('disabled', 'disabled');
    this.removeIcon();
  }

  removeIcon() {
    this.$icon.hide();
  }

  showError(err) {
    this.setButtonText(err);
    console.log(err);
  }

  showSuccess(err) {
    this.setButtonText(err);
  }

  registerHandler() {
    this.disableButton();
    window.startLogin();
  }

  reportSignup() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'newsletter-signup',
    });
  }

  subscribeHandler() {
    this.disableButton();
    this.api
      .subscribe()
      .then(() => {
        this.reportSignup();
        this.showSuccess('Grazie per esserti iscritto');
      })
      .catch(() => {
        this.showError('Si è verificato un errore');
      });
  }
}

document.addEventListener(
  'DOMContentLoaded',
  () => {
    try {
      const api = getApi();
      window.authSession.then(function (userInfo) {
        const widget = new NewsletterWidget('.newsletter--logged', api, userInfo);
        widget.init();
      });
    } catch (err) {
      console.error('unable to inizialize NewsletterAPI:', err);
    }
  },
  false,
);
